import React, { useEffect, useRef } from 'react';

/* Icons */
import { CrossIcon } from "../../common/Icons";

/* Components */
import SearchForm from './SearchForm';
import SearchResults from './SearchResults';

export default function SearchOverlay({ inputValue, setInputValue, closeSearch, recents, typesenseConfig, suluSearchData }) {
    const inputRef = useRef(null);

    useEffect(() => {
        if (inputRef?.current) {
            inputRef.current?.focus();
        }
    }, [inputRef]);

    return (
        <>
            <div className="search__overlay-header">
                <div className="d-flex justify-content-between mb-3 mb-lg-7">
                    <p className="font-weight-bold text-inherit mb-0">{window.Translator.trans('app.header.search.title')}</p>
                    <button
                        title={window.Translator.trans('app.header.search.close')}
                        className="btn btn-none text-base p-0"
                        type="button"
                        onClick={closeSearch}
                    >
                        <CrossIcon className="icon icon--24" />
                    </button>
                </div>

                <label htmlFor="header-search-input" className="sr-only">{window.Translator.trans('app.header.search.title')}</label>
                <SearchForm
                    inputValue={inputValue}
                    setInputValue={setInputValue}
                    inputRef={inputRef}
                />
            </div>
            <div className="search__overlay-body">
                <SearchResults
                    inputValue={inputValue}
                    setInputValue={setInputValue}
                    recents={recents}
                    typesenseConfig={typesenseConfig}
                    suluSearchData={suluSearchData}
                />
            </div>
        </>
    );
}
